const modernOverrides = {
  MuiPaper: {
    styleOverrides: {
      root: {
        backgroundImage: "none",
      },
      rounded: {
        borderRadius: 16,
      },
    },
  },
  MuiTableRow: {
    styleOverrides: {
      root: {
        transition: "background-color .16s ease",
        "&:hover": {
          backgroundColor: "rgba(2, 132, 199, 0.035)",
        },
        "&:last-child td": {
          borderBottom: 0,
        },
      },
    },
  },
  MuiChip: {
    styleOverrides: {
      root: {
        height: 32,
        borderRadius: 9,
        fontWeight: 700,
        fontSize: 12,
      },
      colorPrimary: {
        backgroundColor: "#E0F2FE",
        color: "#0369A1",
      },
    },
  },
  MuiDialog: {
    styleOverrides: {
      paper: {
        borderRadius: 18,
        border: "1px solid #E2E8F0",
        boxShadow: "0 24px 70px rgba(15, 23, 42, 0.16)",
      },
    },
  },
  MuiDialogTitle: {
    styleOverrides: {
      root: {
        color: "#0F172A",
        fontWeight: 800,
        borderBottom: "1px solid #EEF2F7",
      },
    },
  },
  MuiDialogActions: {
    styleOverrides: {
      root: {
        padding: "14px 20px 18px",
        borderTop: "1px solid #EEF2F7",
      },
    },
  },
  MuiPaginationItem: {
    styleOverrides: {
      root: {
        borderRadius: 9,
        fontWeight: 700,
        "&.Mui-selected": {
          color: "#fff",
          backgroundColor: "#0284C7",
          boxShadow: "0 6px 16px rgba(2,132,199,.22)",
        },
      },
    },
  },
  MuiCheckbox: {
    styleOverrides: {
      root: {
        color: "#94A3B8",
        "&.Mui-checked": { color: "#0284C7" },
      },
    },
  },
  MuiRadio: {
    styleOverrides: {
      root: {
        color: "#94A3B8",
        "&.Mui-checked": { color: "#0284C7" },
      },
    },
  },
  MuiSwitch: {
    styleOverrides: {
      switchBase: {
        "&.Mui-checked": {
          color: "#0284C7",
          "& + .MuiSwitch-track": { backgroundColor: "#0284C7" },
        },
      },
    },
  },
  MuiLinearProgress: {
    styleOverrides: {
      barColorPrimary: { backgroundColor: "#0284C7" },
      colorPrimary: { backgroundColor: "#E0F2FE" },
    },
  },
  MuiTooltip: {
    styleOverrides: {
      tooltip: {
        backgroundColor: "#0F172A",
        borderRadius: 8,
        fontSize: 11,
      },
    },
  },
};

export default modernOverrides;
